module.exports = __webpack_public_path__ + "static/img/land4.44a3235.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/land4.jpg
// module id = q4Ca
// module chunks = 0